/**
 * @generated SignedSource<<699497d66ca203e2dc2cf1cb79c46a6d>>
 * @relayHash 549e9d18b9472cf45fb4d355763d038a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7e37fc1c185a453e835e3b673d61dea4e1a5b1f34de3f02eb5162964e39c04fe

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type adminPageQuery$variables = Record<PropertyKey, never>;
export type adminPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"adminPageZitadelStatusFragment">;
};
export type adminPageQuery = {
  response: adminPageQuery$data;
  variables: adminPageQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "adminPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "adminPageZitadelStatusFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "adminPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZitadelStatus",
        "kind": "LinkedField",
        "name": "zitadelStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resources",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "idp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "redirect",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "549e9d18b9472cf45fb4d355763d038a",
    "id": "7e37fc1c185a453e835e3b673d61dea4e1a5b1f34de3f02eb5162964e39c04fe",
    "metadata": {},
    "name": "adminPageQuery",
    "operationKind": "query",
    "text": "query adminPageQuery {\n  ...adminPageZitadelStatusFragment\n}\n\nfragment adminPageZitadelStatusFragment on Query {\n  zitadelStatus {\n    resources\n    idp\n    redirect\n  }\n}\n"
  }
};

(node as any).hash = "67f62d4794a670355897f4644963bf09";

export default node;
